import type { IconProps, ImageProps } from '@chakra-ui/react';
import { Icon, Image } from '@chakra-ui/react';
import React from 'react';

import config from 'configs/app';
// eslint-disable-next-line no-restricted-imports
import logoIcon from 'icons/networks/logo-placeholder.svg';
import { useColorMode } from 'toolkit/chakra/color-mode';

const ChartWatermarkIcon = (props: IconProps) => {
  const { colorMode } = useColorMode();

  // Get logo path based on color mode
  const logoPath =
    colorMode === 'dark' ?
      config.UI.navigation.logo.dark :
      config.UI.navigation.logo.default;

  // If we have an external logo path (string), use Image component
  if (logoPath && typeof logoPath === 'string') {
    // Extract only the compatible props for Image component
    const { w, h, width, height, boxSize } = props;
    const imageProps: Partial<ImageProps> = {
      w: w || width,
      h: h || height,
      boxSize,
    };

    return (
      <Image
        { ...imageProps }
        src={ logoPath }
        position="absolute"
        opacity={ 0.1 }
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        pointerEvents="none"
        alt="Logo watermark"
        objectFit="contain"
      />
    );
  }

  // Otherwise use the default imported SVG icon
  return (
    <Icon
      { ...props }
      as={ logoIcon }
      position="absolute"
      opacity={ 0.1 }
      top="50%"
      left="50%"
      transform="translate(-50%, -50%)"
      pointerEvents="none"
      viewBox="0 0 114 20"
      color={{ _light: 'link', _dark: 'white' }}
    />
  );
};

export default ChartWatermarkIcon;
